import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { getLabels } from "../controllers/translationController";
import { saveSource, setScope, useTranslation } from "./runtime";
import "./translation.css";
import "./direction.css";
import LanguagePicker from "./LanguagePicker";

export default function TranslationProvider({ children }) {
  const { language, isRTL } = useTranslation();
  const { pathname } = useLocation();
  const isVendor = pathname.startsWith("/vendor-") && !pathname.startsWith("/vendor-onboarding");
  const scope = isVendor || /^\/(register|sign-in|privacy|resubmit)/.test(pathname) ? "web" : "admin";
  useLayoutEffect(() => {
    setScope(scope);
    document.documentElement.lang = language === "gr" ? "el" : language;
    document.documentElement.dir = isRTL ? "rtl" : "ltr";
  }, [scope, language, isRTL]);
  useEffect(() => {
    let active = true;
    // Clear web sources before loading: stale cached text must not hide failures.
    const sources = ["common", scope];
    if (scope === "web") {
      sources.forEach((source) => saveSource(language, source, {}));
    }
    for (const source of sources) {
      getLabels(language, source).then((labels) => {
        if (active) saveSource(language, source, labels);
      }).catch(() => {
        if (active && scope === "web") saveSource(language, source, {});
      });
    }
    return () => { active = false; };
  }, [language, scope]);
  return <>
    {/^\/(register|privacy|resubmit)/.test(pathname) && <div className="translation-auth-language"><LanguagePicker /></div>}
    {children}
  </>;
}
